// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FavouritesRecentsCountQueryVariables = Types.Exact<{
  myRecentsFilter: Types.CasinoMyRecentsConnectionFilter;
  myFavouritesFilter: Types.CasinoMyFavouritesConnectionFilter;
}>;


export type FavouritesRecentsCountQuery = { __typename?: 'Query', casino?: { __typename?: 'Casino', id: string, recents?: { __typename?: 'CasinoGameConnection', totalCount?: number }, favourites?: { __typename?: 'CasinoGameConnection', totalCount?: number } } };


export const FavouritesRecentsCountQueryDocument = /*#__PURE__*/ gql`
    query FavouritesRecentsCountQuery($myRecentsFilter: CasinoMyRecentsConnectionFilter!, $myFavouritesFilter: CasinoMyFavouritesConnectionFilter!) {
  casino {
    id
    recents: myRecents(filter: $myRecentsFilter) {
      totalCount
    }
    favourites: myFavourites(filter: $myFavouritesFilter) {
      totalCount
    }
  }
}
    `;
export function useFavouritesRecentsCountQuery(baseOptions: Apollo.QueryHookOptions<FavouritesRecentsCountQuery, FavouritesRecentsCountQueryVariables> & ({ variables: FavouritesRecentsCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavouritesRecentsCountQuery, FavouritesRecentsCountQueryVariables>(FavouritesRecentsCountQueryDocument, options);
      }
export function useFavouritesRecentsCountQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavouritesRecentsCountQuery, FavouritesRecentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavouritesRecentsCountQuery, FavouritesRecentsCountQueryVariables>(FavouritesRecentsCountQueryDocument, options);
        }
export function useFavouritesRecentsCountQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FavouritesRecentsCountQuery, FavouritesRecentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FavouritesRecentsCountQuery, FavouritesRecentsCountQueryVariables>(FavouritesRecentsCountQueryDocument, options);
        }
export type FavouritesRecentsCountQueryHookResult = ReturnType<typeof useFavouritesRecentsCountQuery>;
export type FavouritesRecentsCountQueryLazyQueryHookResult = ReturnType<typeof useFavouritesRecentsCountQueryLazyQuery>;
export type FavouritesRecentsCountQuerySuspenseQueryHookResult = ReturnType<typeof useFavouritesRecentsCountQuerySuspenseQuery>;
export type FavouritesRecentsCountQueryQueryResult = Apollo.QueryResult<FavouritesRecentsCountQuery, FavouritesRecentsCountQueryVariables>;